<app-loading-spinner-overlay *ngIf="!succeeded" [fullPage]="false" [loadingHintTranslationKey]="loadingHintTranslationKey"></app-loading-spinner-overlay>
<div *ngIf="succeeded">
  <ng-content></ng-content>
</div>
